import styled from 'styled-components';
import { Link } from 'core/routing';
import { media as newMedia } from 'styles/utils';
import { media } from 'legacyComponents/styled/styleUtils';
import { Paragraph, Button } from 'components';

// TODO: move shared Tabs styles into its own apps/components
export const TabsWrapper = styled.nav`
  width: 100%;
  overflow-x: auto;
  padding: ${props => props.responsive && `0 ${props.theme.spacing.default}`};
  margin-top: ${props => props.marginTop && props.marginTop};
`;

export const Tab = styled.li`
  flex: 1;
  text-align: center;
  border-bottom: 2px solid
    ${props =>
      props.active ? props.theme.color.wfBlack : props.theme.color.wfGrey200};
  box-shadow: ${props =>
    `inset 0 ${props.active ? '-2px' : 0} 0 0 ${
      props.active ? props.theme.color.wfBlack : 'transparent'
    }`};
  transition: all ease 0.2s;
  > a {
    color: ${props => props.theme.color.wfBlack};
    display: block;
    padding: ${props => props.theme.spacing.medium} 0;
    font-weight: ${props =>
      props.active
        ? props.theme.font.weight.xbold
        : props.theme.font.weight.regular};
    transition: color ease 0.2s;
    &:hover {
      text-decoration: none;
    }
  }
  /* States */
  &:hover {
    box-shadow: ${props =>
      `inset 0 -2px 0 0 ${
        props.active ? props.theme.color.wfBlack : props.theme.color.wfGrey300
      }`};
    border-bottom: 2px solid
      ${props =>
        props.active ? props.theme.color.wfBlack : props.theme.color.wfGrey300};
    > a {
      color: ${props => props.theme.color.wfBlack};
    }
  }
  ${media.s`
    ${props =>
      !props.fullWidth &&
      `
      flex: initial;
      min-width: 33.5%;
    `}
  `};
`;

export const LinkTabStyled = styled(Link)`
  font-size: ${props => props.theme.font.size.default};
  padding: ${props => props.theme.spacing.medium} 0;
  display: block;
`;

export const Tabs = styled.ul`
  width: 100%;
  max-width: ${props => !props.responsive && props.theme.layout.maxWidth};
  padding: 0 ${props =>
    props.noPadding ? '0' : props.theme.layout.paddingInline};
  margin: ${props =>
    props.variant === 'secondary' ? 0 : `${props.theme.spacing.default} auto`};
  display: flex;
  justify-content: ${props =>
    props.variant === 'secondary' ? 'flex-start' : 'space-between'};
  align-items: center;
  border-bottom: ${props =>
    props.variant === 'secondary' &&
    `1px solid ${props.theme.color.wfGrey300}`};
  /* TODO: replace for new media queries */
  ${media.s`
    width: initial;
    margin: ${props => props.responsive && `${props.theme.spacing.default} 0`};
    justify-content: ${props => !props.fullWidth && 'flex-start'};
    align-items: ${props => props.variant === 'secondary' && 'flex-end'};
    border: 0;
    ${Tab} {
      /* FIXME: Remove shitty !important asap once we can have a proper tabs app component */
      border-bottom: ${props =>
        props.variant === 'secondary' &&
        `1px solid ${props.theme.color.wfGrey300} !important`};
        padding: 0 !important;
    }
  `}
  /* Appearance secondary */
  ${props =>
    props.variant === 'secondary' &&
    `
   ${Tab} {
     background-color: transparent;
     border-radius: 0;
     border: 0;
     flex: initial;
     padding: 0 2vw;
     &:hover{
      > a {
        color: ${props.theme.color.primary};
      }
    }
  `}
`;

export const Count = styled.small`
  color: ${props =>
    props.active || props.isGreen
      ? props.theme.color.wfWhite
      : props.theme.color.wfGrey900};
  font-weight: ${props => props.theme.font.weight.xbold};
  background-color: ${props =>
    props.active
      ? props.theme.color.primary
      : props.isGreen
      ? props.theme.color.wfGreen
      : props.theme.color.wfGrey200};
  padding: 1px 4px;
  border-radius: ${props => props.theme.borderRadius.small};
  margin-left: ${props => props.theme.spacing.small};
`;

export const NotifCount = styled.small`
  height: ${props => props.theme.font.size.medium};
  width: ${props => (props.isPill ? 'auto' : props.theme.font.size.medium)};
  background-color: ${props =>
    props.variant === 'success'
      ? props.theme.color.wfGrey300
      : props.theme.color.wfOrange};
  border-radius: ${props => (props.isPill ? '20px' : '50%')};
  position: absolute;
  top: ${props =>
    !props.isStatic &&
    (props.isMobile ? '-5px' : `-${props.theme.spacing.xsmall}`)};
  right: ${props =>
    !props.isStatic &&
    (props.isMobile ? '-5px' : `-${props.theme.spacing.xsmall}`)};
  color: ${props => props.theme.color.wfWhite};
  font-size: ${props => props.theme.font.size.xsmall};
  margin-left: ${props => props.isStatic && props.theme.spacing.small};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-weight: ${props =>
    props.isPill
      ? props.theme.font.weight.xbold
      : props.theme.font.weight.regular};
  vertical-align: ${props => props.isStatic && 'top'};
  padding: ${props =>
    props.isPill
      ? `${props.theme.spacing.xsmall} ${props.theme.spacing.default}`
      : 0};
`;

export const TabsContentCount = styled(NotifCount)`
  position: relative;
  vertical-align: sub;
  background-color: ${props => props.theme.color.wfGrey50};
  border: 1px solid ${props => props.theme.color.wfGrey100};
  color: ${props => props.theme.color.wfBlack};
  margin-left: 0.5rem;
  padding: 0 0.5rem;
  width: auto;
  border-radius: 20px;
`;

export const Dot = styled.small`
  color: ${props =>
    props.variant === 'success'
      ? props.theme.color.wfGreen
      : props.theme.color.wfYellow};
  font-size: ${props => props.theme.font.size.xsmall};
  margin: 0 ${props => props.theme.spacing.small};
  display: inline-block;
`;

export const ButtonGroup = styled.nav`
  width: 100%;
  padding: ${props =>
    props.theme.spacing[props.spacing] || props.theme.spacing.default};
  text-align: ${props => props.textAlignment || 'center'};
  ${props =>
    props.isFixed &&
    `
    position: fixed;
    background-color: ${props.theme.color.wfWhite};
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: 0 -6px 6px 0 rgba(0,0,0,0.07);
  `};
  > div {
    max-width: 600px;
    margin: 0 auto;
    display: flex;
    justify-content: ${props => props.alignment || 'center'};
    align-items: center;
  }
  > *:not(div) {
    &:first-child {
      margin-right: ${props =>
        `calc(${props.theme.spacing[props.spacing] ||
          props.theme.spacing.default} / 2)`};
    }
    &:last-child {
      margin-left: ${props =>
        `calc(${props.theme.spacing[props.spacing] ||
          props.theme.spacing.default} / 2)`};
    }
  }
  /* Media queries */
  ${newMedia.large`
    width: ${props => props.isFixed && props.widthContainer};
  `}
`;

export const Divider = styled.hr`
  height: ${props => props.height || '1px'};
  background-color: ${props =>
    props.theme.color[props.color] ||
    props.color ||
    props.theme.color.wfGrey200};
  border: none;
  margin: ${props => `${props.theme.spacing[props.spacing]} 0` || 0};
`;

export const Pattern = styled.div.attrs(() => ({
  'aria-hidden': 'true',
}))`
  width: ${props => props.size || props.width};
  height: ${props => props.size || props.height};
  display: none;
  ${props =>
    props.hasPattern
      ? `
    background: radial-gradient(
      ellipse at center,
      ${props.theme.color[props.backgroundColor] || props.backgroundColor} 0%,
      ${props.theme.color[props.backgroundColor] || props.backgroundColor} 12%,
      transparent 10%
    );
    background-size: 20px 20px;
    background-repeat: repeat;
    opacity: .5;
  `
      : `
    background-color: ${props.theme.color[props.backgroundColor] ||
      props.backgroundColor};
  `}
  position: fixed;
  top: ${props => props.top};
  right: ${props => props.right || 0};
  bottom: ${props => props.bottom || 0};
  left: ${props => props.left};
  z-index: ${props => props.zIndex || -1};
  transform: ${props => props.rotate && `rotate(${props.rotate}deg)`};
  ${props =>
    props.borderColor &&
    `
    &::before {
      position: absolute;
      border: 1px solid ${props.theme.color[props.borderColor] ||
        props.borderColor};
      width: 120%;
      height: 120%;
      content: '';
      left: -15%;
      top: -15%;
      opacity: .2;
    }
  `};
  /* Media queries */
  ${newMedia.large`
    display: block;
  `}
`;

export const ProTip = styled(Paragraph)`
  margin: ${props => props.theme.spacing.default} 0;
  color: ${props => props.theme.color.wfGrey800};
`;

export const ButtonShowMore = styled(Button)`
  margin: 0 auto ${props => props.theme.spacing.large};
  display: block;
`;

export const CenteredButtonWrapper = styled.div`
  margin: auto;
  display: flex;
  justify-content: center;
`;

export const Avatar = styled.img`
  width: ${props => props.size || '44px'};
  height: ${props => props.size || '44px'};
  border-radius: 50%;
  transition: opacity 100ms ease-in-out;
  float: ${props => props.float || 'none'};
  background-color: ${props => props.theme.color.wfWhite};
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
  display: ${props => props.display || 'initial'};
  &:hover {
    opacity: ${props => (props.noOpacity ? '1' : '0.8')};
    cursor: pointer;
  }
`;

export const ProfileAvatar = styled(Avatar)`
  width: 120px;
  height: 120px;
  margin-top: -50px;
  border: 1px solid ${props => props.theme.color.wfGrey200};
  z-index: 14;
`;

export const Username = styled(Link)`
  color: ${props => props.theme.color.wfGrey700};
  cursor: pointer;
  color: ${props => props.theme.color.wfBlue};
  &:hover {
    text-decoration: underline;
  }
`;
